module.exports = __webpack_public_path__ + "assets/think.c7fb74d3.svg";